import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function AddKeywordsGenerate({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Add Keywords - Generate'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

